import { render } from "./radar.vue?vue&type=template&id=00dbc68b&scoped=true&ts=true"
import script from "./radar.vue?vue&type=script&lang=ts"
export * from "./radar.vue?vue&type=script&lang=ts"

import "./radar.vue?vue&type=style&index=0&id=00dbc68b&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dbc68b"]])

export default __exports__